import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView         from "./TemplateListView";
import LocationAdminDetailsView from "./LocationAdminDetailsView";
import LocationAdminNewView     from "./LocationAdminNewView";


const LocationAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "LocationAdmin.pageState";
  const defaultPageState = {
    searchField: "Code",
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Code"),
      sortable: true,
      sortField: 'code',
      grow: 2.5,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Type"),
      selector: row => t("I18N_LOC_TYPE_" + row.type),
      sortable: true,
      sortField: 'type',
    },
    {
      name: t("I18N_Site"),
      selector: row => row.site,
    },
    {
      name: t("I18N_Building"),
      selector: row => row.building,
    },
    {
      name: t("I18N_Wing"),
      selector: row => row.wing,
      sortable: true,
      sortField: 'wing',
    },
    {
      name: t("I18N_Floor"),
      selector: row => row.floor,
      sortable: true,
      sortField: 'floor',
    },
    {
      name: t("I18N_Room"),
      selector: row => row.room,
      sortable: true,
      sortField: 'room',
    },
/*
    {
      name: t("I18N_Ext_sys_id"),
      selector: row => row.externalSystemId,
    },
*/
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----

  const searchFieldOptions = [
    { key: "CODE",  value: "CODE" },
    { key: "DESCRIPTION", value: "DESCRIPTION" }
  ];


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API} apiObjName={'locations'}
                                                  listPageTitle={t("I18N_Location_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_loc")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Location_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_loc")}
                                                  deleteObjNameField={"code"}
                                                  tableColumns={tableColumns}
                                                  searchFieldOptions={searchFieldOptions}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <LocationAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />          : null}
      {(uiMode === 'NEW')     ? <LocationAdminNewView     onUIMode={setUIMode} />                                  : null}

    </Fragment>
  )
}

export default LocationAdmin;
